import { render, staticRenderFns } from "./SettingsConsent.vue?vue&type=template&id=8b8f07f2&scoped=true"
import script from "./SettingsConsent.vue?vue&type=script&lang=js"
export * from "./SettingsConsent.vue?vue&type=script&lang=js"
import style0 from "./SettingsConsent.vue?vue&type=style&index=0&id=8b8f07f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8f07f2",
  null
  
)

export default component.exports